import Swiper from 'swiper/bundle';

export default (scroller) => {
  if(document.querySelector('.team-profile')){
    var teamProfileSlider = new Swiper('.team-profile-slider', {
      slidesPerView: 'auto',
      mousewheel: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChange: function () {
          scroller.scrollTo(0,0);
        },
      },
    });

    // let innerScrollers = document.querySelectorAll(".inner-description-wrapper");

    // innerScrollers.forEach((innerScroller) => {
    //   if(window.innerWidth > 840){
    //     innerScroller.onmouseout = function(event) { scroller.start(); };

    //     let isScrolling;

    //     innerScroller.addEventListener('scroll', () => {
    //       scroller.stop();

    //       var scrollTop = innerScroller.scrollTop;
    //       var scrollHeight = innerScroller.scrollHeight;
    //       var offsetHeight = innerScroller.offsetHeight;
          
    //       var contentHeight = scrollHeight - offsetHeight;

    //       if (contentHeight <= scrollTop){
    //         scroller.start();
    //       } else {
    //         scroller.stop();
    //       }

    //       window.clearTimeout( isScrolling );
    //       isScrolling = setTimeout(function() {
    //         scroller.start();
    //       }, 66);
          
    //     }, false);

    //   }
    // });
  }
}